export default __webpack_public_path__ + "static/media/UVA-small.c3f8190a.png";